import { HelpOutline, WarningOutlined } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'

import CustomTypography from '@/components/dataDisplay/CustomTypography'

export function ControllerTooltip() {
  return (
    <Tooltip
      placement="left"
      title={
        <CustomTypography>
          Here you can configure (as of now):
          <ul style={{ marginTop: 4, marginBottom: 18, paddingLeft: 18 }}>
            <li>Serial port settings</li>
            <li>Power meters: Tillquist, Algodue, Schneider, Modbus</li>
          </ul>
          <Box alignItems="center" display="flex" gap={1} mb={2} mt={1}>
            <WarningOutlined color="warning" /> Warning icons indicate problems with current configuration.
          </Box>
          This UI may automatically propose to fix those and also to:
          <ul style={{ marginTop: 4, marginBottom: 18, paddingLeft: 18 }}>
            <li>make default settings explicit</li>
            <li>remove legacy settings that have no effect</li>
          </ul>
          Please review, correct (if needed) and apply the proposals. They cannot be canceled, but should go away once
          applied.
        </CustomTypography>
      }
    >
      <HelpOutline color="primary" fontSize="medium" />
    </Tooltip>
  )
}
